import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const noop = () => {};

const FilterGroup = ({
  children = null,
  label = '',
  tooltip = noop,
  classModifier = ''
}) => {
  const classnames = classNames('filter-group', {
    [`filter-group--${classModifier}`]: classModifier
  });

  return (
    <div className={classnames}>
      <div className="filter-group-left-side">
        <div className="filter-group-left-side__label">
          <span>{label}</span>
          {tooltip()}
        </div>
      </div>
      <div className="filter-group-right-side">{children}</div>
    </div>
  );
};

FilterGroup.propTypes = {
  label: PropTypes.string,
  classModifier: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  tooltip: PropTypes.func
};

export default memo(FilterGroup);
